module.exports = __webpack_public_path__ + "static/media/signin-back.f6e36e8a.png";